import { Time } from './time';

export const OTAFileTypes = {
  'device-config': { destination: 'device-config' },
  openalpr: { destination: 'openalpr' },
  lpr_key: { destination: 'lpr_key' },
  'network-switcher-config': { destination: 'network-switcher-config' },
  'aim-config': { destination: 'aim-config' },
  'camera-config-day': { destination: 'camera-config-day' },
  'camera-config-night': { destination: 'camera-config-night' },
  'able-config': { destination: 'able.json' },
  'route-config': { destination: 'route-config' },
  'permitted-list': { destination: 'permitted-list.json' },
} as const;

export enum OTAFileCategories {
  AbleConfig = 'able-config',
  UbloxConfigs = 'ublox-config',
  UbloxFirmware = 'ublox-firmware',
  STMFirmware = 'stm-firmware',
  PermittedPlates = 'permitted-plates-list',
  Compose = 'compose',
  CameraISPFirmware = 'camera-isp-firmware',
  Gen3CameraISPFirmware = 'gen3-camera-isp-firmware',
  OSAB = 'os-ab',
}

export const OTAFileCategoryTypes = ['string', 'int', 'float', 'bool', 'ota-file'] as const;

export enum OTAFileSources {
  FormMetadataSource = 'form',
  FileContentMetadataSource = 'file-content',
  NoneMetadataSource = '',
}

export interface OTAFile {
  destination?: string;
  id?: number;
  key?: string;
  md5?: string;
  presigned_url?: string;
  updated_at?: Time;
  bucket?: string;
}

export interface OTAFileV2 {
  id?: number;
  destination?: string;
  category?: keyof typeof OTAFileTypes | string;
  key?: string;
  presigned_url?: string;
  device_file_id?: number;
  bucket?: string;
  md5?: string;
  content?: string;
  created_at?: string;
  created_by?: string;
  metadata: Record<string, string>;
}

export interface OTAFileCategory {
  ota_file_category_id?: number;
  category: string;
  source: OTAFileSources;
  metadata_fields: Array<{
    name: string; // should not contain "-" nor spaces, it's variable name
    type?: 'ota-file' | 'int' | 'float' | 'bool' | 'string'; // enum of string/int/float/bool/ota-file
    required: boolean; // checkbox
    ref_category?: string; // dropdown based on all categories
  }>;
}
